import AutopayTable from "./view/AutopayTable";

const Autopay = () => {
  return <AutopayTable />;
};

export default Autopay;
